module.exports = __webpack_public_path__ + "static/media/63.2709e384.jpg";